<template>
  <div class="intro-zhibo-container">
    <common-header></common-header>
    <div class="header-banner"></div>
    <!-- 直播价值 -->
    <common-advantage :advantages="valuesList"></common-advantage>
    <!-- 直播优势 -->
    <common-advantage :advantages="advantageList"></common-advantage>
    <!-- 直播功能 -->
    <common-advantage :advantages="functionList"></common-advantage>
    <!-- 直播解决方案 -->
    <div class="application-wrap resolution-wrap">
      <common-application title="直播解决方案" :tabcontent="tabcontent"></common-application>
    </div>
    <!-- 直播应用案例 -->
    <div class="application-wrap appcase-wrap">
      <common-application title="直播应用案例" :tabfilter="tabsfilter2" :tabcontent="tabcontent2"></common-application>
    </div>
    <common-footer></common-footer>
  </div>
</template>
<script>
import mainHeader from '@/components/mainheader'
import mainFooter from '@/components/mainfooter'
import advantage from '@/components/advantage'
import application from '@/components/application'
export default {
  name: 'app',
  components: {
    'common-header': mainHeader,
    'common-footer': mainFooter,
    'common-advantage': advantage,
    'common-application': application
  },
  data () {
    return {
      tabsfilter2: ['汽车之家直播应用', '某平台直播应用'],
      tabcontent: ['zb-banner2'],
      tabcontent2: ['zb-banner3', 'zb-banner4'],
      currentTabIndex: 0,
      currentTabIndex2: 0,
      hoverIndex: -1,
      valuesList: {
        title: '直播价值',
        mulitrow: false,
        list: [
          {
            key: '0',
            title: '场景线上化',
            desc: '比传统图文形式的车讯信息，现场实景展示，让内容更加立体化，具有真实感，信息量更广',
            iconname: 'icon-zb-01'
          },
          {
            key: '1',
            title: '用户互动',
            desc: '主播与用户在直播期间，可以通过弹幕、礼物、点赞等方式进行实时互动，突破传统视频单向输出的枯燥，增强用户的参与感，同时增加用户粘性',
            iconname: 'icon-zb-02'
          },
          {
            key: '2',
            title: '商业变现',
            desc: '借助商品橱窗功能，直播内容引导售卖，让直播内容更加价值',
            iconname: 'icon-zb-03'
          },
          {
            key: '3',
            title: '时效性高',
            desc: '文章和视频资讯都需要撰写和剪辑的过程后，才能呈现到用户面前，难免会有信息滞后的情况，但直播可以做到信息无时差同步',
            iconname: 'icon-zb-04'
          }
        ]
      },
      advantageList: {
        title: '直播优势',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '最大意向用户覆盖，实时互动',
            desc: '智能系统覆盖高意向用户，直播间内丰富互动，获取更多一手信息',
            iconname: 'icon-zb-05'
          },
          {
            key: '1',
            title: '高自由度、灵活便捷',
            desc: '提供多样营销工具，满足高定制化需要，全面助力价值转化',
            iconname: 'icon-zb-06'
          },
          {
            key: '2',
            title: '流畅、清晰、稳定',
            desc: '支持百万级同在线，以及千万级播放次数，丰富的国际车展经验，业内一流的视频推流和转码技术',
            iconname: 'icon-zb-07'
          }
        ]
      },
      functionList: {
        title: '直播功能',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '视频采集SDK',
            desc: '丰富的终端推流功能，支持多终端适配，上行码率自适应等功能，满足客户不同场景需求',
            iconname: 'icon-zb-08'
          },
          {
            key: '1',
            title: '视频播放SDK',
            desc: '多平台播放SDK方便快速接入，全网加速提供多屏下的极致播放体验',
            iconname: 'icon-zb-09'
          },
          {
            key: '2',
            title: '直播推流',
            desc: '国内领先的CDN技术，高质BGP网络，多方位保证直播传输质量',
            iconname: 'icon-zb-10'
          },
          {
            key: '3',
            title: '直播转码',
            desc: '覆盖主流直播转码格式，专业，高可定制转码模板',
            iconname: 'icon-zb-11'
          },
          {
            key: '4',
            title: '智能AI',
            desc: '基于深度学习，计算机视觉技术和海量数据，提供多场景视频AI服务',
            iconname: 'icon-zb-12'
          },
          {
            key: '5',
            title: '营销转化工具',
            desc: '提供多场景、多形式的转化工具，全方位保障直播内容的价值落地',
            iconname: 'icon-zb-13'
          }
        ]
      }
    }
  },
  created(){
    // pv上报
    // 埋点
    window.pvTrack = {
      site: 144,
      category: 1726,
    }
    window.trackPageView()
  },
  methods: {}
}
</script>

<style scoped>
.intro-zhibo-container {
  background-color: #F7F9FA;
}
.header-banner {
  width: 100%;
  height: 542px;
  background-size: cover;
  background-image: url('./../assets/images/index-banner4.png');
  background-repeat: no-repeat;
  background-position: -2px 0;
  position: relative;
  top: -1px;
}
.application-wrap {
  margin-bottom: -2px;
}
.resolution-wrap {
  padding-top: 10px;
  background: #333B5B;
  margin-top: 50px;
}
.appcase-wrap {
  padding-top: 10px;
  background: #333B5B;
  margin-top: 0;
}
.intro-zhibo-container .application-title .line i {
  background: rgba(202,206,213,.5);
}
</style>



// WEBPACK FOOTER //
// src/view/intro_zhibo.vue